/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import readAloudIcon from "dc-icons/viewer2021/SDC_ReadAloudListen_18_N.svg";
import CustomIcon from "dc-preview-utils/src/components/CustomIcon";

import ReadAloudCss from "./readAloud.css";

export const ReadAloudIcon = () => (
  <div className={ReadAloudCss.icon}>
    <CustomIcon url={readAloudIcon} />
  </div>
);
